import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserDto } from 'shared';
import { NotificationService } from 'shared';
import { TenantService } from 'shared';
import { TranslateService } from 'shared';
import { DeleteUserDialogComponent } from '../../user-management/delete-user-dialog/delete-user-dialog.component';
import { ApiTokenDto } from 'shared';

@Component({
    selector: 'app-delete-apitoken-dialog',
    templateUrl: './delete-apitoken-dialog.component.html',
    styleUrls: ['./delete-apitoken-dialog.component.scss'],
    standalone: false
})
export class DeleteApitokenDialogComponent implements OnInit {
  userDeleteForm!: UntypedFormGroup;
  userDto!:ApiTokenDto;
  userName!: string;

  constructor(private fb: UntypedFormBuilder,
    public translate: TranslateService,
    public dialogRef: MatDialogRef<DeleteApitokenDialogComponent>,
    private tenantService: TenantService,
    private notificationService: NotificationService,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    this.userDto = this.data.userDto;
    console.log("========================> userDto = ", this.userDto)
    // if (this.userDto.last_Name)
    //   this.userName = this.userDto.first_Name + " " + this.userDto.last_Name;
    // else
    //   this.userName = "";
    // console.log("========================> userName = ", this.userName)
    //this.userDto.user_Name = (this.userName!=" (not confirmed)")?this.userName:this.userDto.email;
    this.buildUserDeleteForm(this.userDto);
  }

  buildUserDeleteForm(userDto: ApiTokenDto) {
    this.userDeleteForm = this.fb.group({
      id:[userDto.id],
      userName:[userDto.user_Name]
    });
  }

  deleteUser(id: string) {
    if(this.userDeleteForm.valid){      
      // let db:string = this.tenantService.currentTenantName;
      // let dbId:string = this.tenantService.currentTenantId;

      // console.log("==============> remove user from tenant: dbId = ", dbId)

      // this.tenantService.deleteUser(db, dbId, this.userDto.id).subscribe({
      //   next:() => {
      //     this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `${this.translate.data["USERDELETED"]}`);
      //   },
      //   error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["USERUSERDELETEDERROR"]}`)
      // });

      this.dialogRef.close(this.userDeleteForm.value);
    }
  }

  cancel(){
    this.dialogRef.close();
  }
}
